<template>
  <div
    class="d-flex content-center min-vh-100 w-100 login-page"
    :style="background ? `background-image: url('${background.url}')` : ''"
  >
    <CModal
      :title="modal.title"
      :color="modal.color"
      :show.sync="modal.show"
      :centered="true"
      class="text-left"
    >
      {{ modal.message }}
    </CModal>

    <CContainer>
      <CRow class="d-flex content-center">
        <CCol
          sm="12"
          md="12"
          lg="6"
        >
          <CCardGroup>
            <CCard
              class="p-4"
              accent-color="light"
            >
              <CCardBody>
                <CForm @submit.prevent="send">
                  <div class="d-inline-block w-100 mb-4">
                    <div
                      class="
                        card-image
                        d-flex
                        justify-content-center
                        w-100
                        logo-box
                      "
                    >
                      <img
                        v-if="logo"
                        :src="logo.url"
                        :alt="logo.title"
                      />
                      <img
                        v-if="firstLoadLogo && !logo"
                        src="@/assets/img/logo-primary.svg"
                        alt="ow-logo-black"
                      />
                    </div>
                    <small class="text-muted d-inline-block w-100 mt-3">{{
                      showForgotPassword
                        ? 'Enviaremos um e-mail de recuperação de senha para sua caixa de entrada'
                        : 'Acesse o painel administrativo utilizando seu e-mail e senha.'
                    }}</small>
                  </div>
                  <CInput
                    v-model="form.email"
                    placeholder="Digite o seu e-mail"
                    type="email"
                    required
                    :disabled="processing"
                  ></CInput>
                  <CInput
                    v-if="!showForgotPassword"
                    v-model="form.password"
                    placeholder="Digite a sua senha"
                    type="password"
                    required
                    :disabled="processing"
                  ></CInput>
                  <CRow>
                    <CCol
                      col="6"
                      class="text-left"
                    >
                      <CButton
                        color="link"
                        type="button"
                        style="
                          padding-left: 0px !important;
                          padding-right: 0px !important;
                        "
                        @click="
                          () => (showForgotPassword = !showForgotPassword)
                        "
                      >
                        {{
                          showForgotPassword
                            ? 'Voltar para login'
                            : 'Esqueceu sua senha?'
                        }}
                      </CButton>
                    </CCol>
                    <CCol
                      col="6"
                      class="text-right"
                    >
                      <CButton
                        color="info"
                        class="px-4"
                        type="submit"
                        :disabled="processing"
                      >
                        <template v-if="processing">
                          {{
                            showForgotPassword ? 'Enviando...' : 'Aguarde...'
                          }}
                        </template>
                        <template v-else>
                          {{ showForgotPassword ? 'Enviar' : 'Entrar' }}
                        </template>
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AuthService from '@/services/auth.service'
import SettingService from '@/services/settings.service'

import Cookies from 'js-cookie'

export default {
  metaInfo: {
    title: 'Login',
    titleTemplate: ' %s - Manager - Intelli'
  },

  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      token: null,
      modal: {
        show: false,
        title: '',
        message: ''
      },
      logo: '',
      firstLoadLogo: false,
      background: '',
      showForgotPassword: false,
      processing: false,
      logged: false
    }
  },

  computed: {
    ...mapGetters('auth', ['loggedIn', 'roles'])
  },

  async created() {
    this.logged = Cookies.getJSON('intelli:user')
    this.userHaveTwoFactorAuth = Cookies.getJSON('intelli:userHaveTwoFactorAuth')
    if (this.userHaveTwoFactorAuth) {
      return this.$router.push('/validate-token')
    }
    if (this.logged) {
      return this.$router.push('/dashboard')
    }
    await this.getLogo()
  },

  methods: {
    ...mapActions('auth', ['login', 'logout']),

    async getLogo() {
      const data = await SettingService.listAllMedias()
      this.background = data.background && data.background[0]
      this.logo = data.background && data.coloredLogo[0]
      this.firstLoadLogo = true
    },

    send() {
      if (this.showForgotPassword) {
        this.forgetPassword()
      } else {
        this.loginUser()
      }
    },

    async forgetPassword() {
      this.processing = true

      const response = await AuthService.passReset(this.form.email)

      this.processing = false

      if (response === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message:
            'Um link para alteração da sua senha foi enviada para seu e-mail.',
          color: 'success'
        }
      } else if (response === 403) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Já existe um token valido, por favor verifique seu e-mail',
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message:
            'O e-mail preenchido não existe em nossa base de dados, por favor tente outro e-mail.',
          color: 'danger'
        }
      }
    },

    async loginUser() {
      this.processing = true

      const user = {
        login: this.form.email,
        password: this.form.password
      }

      const response = await AuthService.login(user)
      this.processing = false

      if (response.token) {
        if (response.user_have_two_factor_auth) {
          await this.login(response.token)
        } else {
          await this.login(response.token)
          this.$router.push('/dashboard')
        }
      } else {
        this.logout()
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'E-mail e/ou senha incorreto, por favor tente novamente.',
          color: 'danger'
        }
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.login-page {
  background: #3A3A3A;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  .card {
    border-left: none;
    border-bottom: none;
    border-right: none;

    .card-image {
      img {
        max-height: 80px;
      }
    }

    .form-group {
      .input-group {
        .input-group-text {
          background: $info;
          border-color: $info;
          color: $white;
        }
      }
    }
  }

  .modal {
    .modal-footer {
      display: none;
    }
  }
}

.logo-box {
  min-height: 40px;
}
</style>
